import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { RoleGuard } from "@/components/shared/guards/role-guard";
import { RoleBasedAccessPage } from "@/features/role-based-access";

export const Route = createFileRoute("/settings/role-based-access")({
  component: () => (
    <PermissionGuard module="role_access">
      <RoleGuard allowedRoles={["tenant_owner"]}>
        <RoleBasedAccessPage />
      </RoleGuard>
    </PermissionGuard>
  ),
});
